import React from "react";
import { useLang } from "@/i18n/LangContext";
import { pageContent, pickLang } from "@/i18n/pageContent";

export const IntroSection = () => {
  const { lang } = useLang();
  const c = pickLang(pageContent.home, lang).intro;
  return (
    <section
      data-testid="home-intro"
      className="bg-white pt-16 sm:pt-20 pb-8"
    >
      <div className="ll-container max-w-4xl text-center">
        <span className="inline-block text-[#2E9CD6] font-[Poppins] font-semibold text-xs uppercase tracking-[0.2em] mb-4">
          {c.eyebrow}
        </span>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6">
          {c.title}
        </h2>
        <div className="space-y-4 text-base sm:text-lg text-[#3E5871] font-[Inter] leading-relaxed">
          <p>{c.p1}</p>
          <p>{c.p2}</p>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
